<script setup>
import { ref, watch } from 'vue';
import Dropdown from 'primevue/dropdown';

const TYPES_OCCURRENCE = [
	{nom: 'UNE', libelle: 'Un seul objet'},
	{nom: 'PLUSIEURS', libelle: 'Plusieurs objets'}
];

const { typeOccurrence, desactive } = defineProps({
    typeOccurrence: String,
    desactive: Boolean
});

const emit = defineEmits(['update:typeOccurrence', 'modification']);

const typeOccurrenceSelectionne = ref(getTypeOccurrence(typeOccurrence));

watch(() => typeOccurrence, (t) => {
    typeOccurrenceSelectionne.value = getTypeOccurrence(t);
});

function getTypeOccurrence(t) {
	return TYPES_OCCURRENCE.find(type => type.nom === t);
}

function modifierTypeOccurrence(t) {
    if (t.nom && t.nom !== typeOccurrence) {
        emit('update:typeOccurrence', t.nom);
        emit('modification', t);
    }
}

</script>

<template>
    <Dropdown 
      v-model="typeOccurrenceSelectionne" 
      :options="TYPES_OCCURRENCE" 
      optionLabel="libelle"
      :disabled="desactive"
      placeholder="Indéfini"
      @change="modifierTypeOccurrence($event.value)"/>
</template>

<style scoped>

</style>